// extracted by mini-css-extract-plugin
export default {"modal":"TaskForm_modal__PdVzk","title":"TaskForm_title__GBuVE","formContainer":"TaskForm_formContainer__tSoqY","label":"TaskForm_label__Klhfo","btn":"TaskForm_btn__dQQSe"};